export type ParseSignatureExpiresAtResult =
  | { ok: true; iso: string | null }
  | { ok: false; message: string };

export function parseSignatureExpiresAtInput(value: string): ParseSignatureExpiresAtResult {
  if (!value.trim())
  {
    return { ok: true, iso: null };
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime()))
  {
    return { ok: false, message: 'Prazo para assinatura inválido.' };
  }

  if (parsed.getTime() <= Date.now())
  {
    return { ok: false, message: 'O prazo para assinatura deve ser uma data futura.' };
  }

  return { ok: true, iso: parsed.toISOString() };
}
